<script setup lang="ts">
import { useState } from '#app'
import { computed } from 'vue'
import type { CmsData, CmsLink } from '~/layers/cms/app/types/cmsTypes'
import { getByPath } from '../../utils/cmsDataHelper'

const cmsData = useState<CmsData>('cmsData')

if (!cmsData) {
  throw new Error('cmsData not provided')
}

const props = defineProps<{
  cmsDataPath: (string | number)[]
  global?: boolean
}>()

const link = computed(() => getByPath(cmsData.value, props.cmsDataPath)?.component_data as CmsLink)
</script>

<template>
  <div v-cms-link-element:[link]="{ path: props.cmsDataPath, global: props.global }">
    <slot :link="link">
      <NuxtLink
        :to="link?.href ?? 'Lorem ipsum'"
        :target="link?.target ?? 'Lorem ipsum'"
        :rel="link?.rel"
        :aria-label="link?.aria_label"
      >
        <div class="link-text">{{ link?.link_text ?? 'Lorem ipsum' }}</div>
      </NuxtLink>
    </slot>
  </div>
</template>
